import { z } from 'zod';

interface ChangePasswordSchemaOptions {
  minLengthMessage?: string;
  numberRequiredMessage?: string;
  passwordsMismatchMessage?: string;
}

export const changePasswordSchema = ({
  minLengthMessage = 'La password deve avere almeno 8 caratteri',
  numberRequiredMessage = 'La password deve contenere almeno un numero',
  passwordsMismatchMessage = 'Le password non coincidono',
}: ChangePasswordSchemaOptions) =>
  z
    .object({
      password: z.string().min(8, minLengthMessage).regex(/\d/, numberRequiredMessage),
      confirmPassword: z.string(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: passwordsMismatchMessage,
      path: ['confirmPassword'], // Indica il campo che mostra l'errore
    });

export type ChangePasswordFormInputs = z.infer<ReturnType<typeof changePasswordSchema>>;
